<script setup lang="ts">
import { useScreen } from "@/composable/useResponsive";

defineProps<{
  img: string;
  title: string;
  actions: {
    label: string;
    description?: string;
    handler: () => void;
  }[];
}>();

const { screen } = useScreen();
</script>

<template>
  <div class="bg-blue-gradient txt-white w-full">
    <div class="d-flex flex-row gap-2">
      <div
        v-if="screen.gt.sm"
        class="col-2 d-flex align-items-end justify-content-start"
      >
        <img :src="img" alt="Banner Image" width="150" style="height: 150px" />
      </div>
      <div class="col p-4 d-flex flex-column w-100 gap-3">
        <h4 class="txt-white">{{ title }}</h4>
        <div class="row g-3">
          <div
            v-for="action in actions"
            :key="action.label"
            :class="actions.length >= 2 ? 'col-12 col-lg-6' : 'col-12'"
          >
            <el-card
              @click="action.handler"
              class="h-100 rounded-0 card-action border-0 cursor-pointer"
              shadow="hover"
            >
              <div
                class="h-full d-flex flex-row justify-content-between align-items-center gap-3"
              >
                <div class="d-flex flex-column gap-1">
                  <span v-if="action.description" class="h5 txt-white">
                    {{ action.label }}</span
                  >
                  <span class="text-grey">{{
                    action.description ?? action.label
                  }}</span>
                </div>

                <el-icon size="2rem" color="grey"
                  ><i class="bi-chevron-right"
                /></el-icon>
              </div>
            </el-card>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.card-action {
  background: #3a437c;
  color: #fff !important;
  &:hover {
    background: #4a4f8c;
  }
}

.txt-white {
  color: #fff !important;
}
</style>
